module.exports = __webpack_public_path__ + "01c458ff25dfbb7de8eb9ee344e347b6.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-pilar-03.jpg
 ** module id = 368
 ** module chunks = 0
 **/